import { useMediaQuery } from "react-responsive";

export const useScreenSize = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 639px)" });
  return { isMobileScreen };
};
